import CaptainNativeSkills from 'dashboard/api/captain/nativeSkills';
import { createStore } from '../storeFactory';
import { throwErrorMessage } from 'dashboard/store/utils/api';

export default createStore({
  name: 'CaptainNativeSkill',
  API: CaptainNativeSkills,
  getters: {
    getRecords: state =>
      [...state.records].sort((a, b) => a.position - b.position),
  },
  actions: mutations => ({
    update: async ({ commit }, { id, assistantId, ...updateObj }) => {
      commit(mutations.SET_UI_FLAG, { updatingItem: true });
      try {
        const response = await CaptainNativeSkills.update(
          { id, assistantId },
          updateObj
        );
        commit(mutations.EDIT, response.data);
        return response.data;
      } catch (error) {
        return throwErrorMessage(error);
      } finally {
        commit(mutations.SET_UI_FLAG, { updatingItem: false });
      }
    },

    delete: async ({ commit }, { id, assistantId }) => {
      commit(mutations.SET_UI_FLAG, { deletingItem: true });
      try {
        await CaptainNativeSkills.delete({ id, assistantId });
        commit(mutations.DELETE, id);
        return id;
      } catch (error) {
        return throwErrorMessage(error);
      } finally {
        commit(mutations.SET_UI_FLAG, { deletingItem: false });
      }
    },

    reorder: async ({ commit }, { assistantId, skillIds }) => {
      commit(mutations.SET_UI_FLAG, { updatingItem: true });
      try {
        const response = await CaptainNativeSkills.reorder({
          assistantId,
          skillIds,
        });
        commit(mutations.SET, response.data.payload);
        return response.data.payload;
      } catch (error) {
        return throwErrorMessage(error);
      } finally {
        commit(mutations.SET_UI_FLAG, { updatingItem: false });
      }
    },
  }),
});
